'use client'

import { useTranslations } from 'next-intl'
import { useRouter } from '@/i18n/routing'
import { useImageCompressorStore } from '@/stores/use-image-compressor-store'
import { FileDropZone } from '@/components/shared/FileDropZone'
import { ToolStepIndicator } from '@/components/shared/ToolStepIndicator'
import { trackToolEvent } from '@/lib/utils/analytics'

export function ImageUploadStep() {
    const t = useTranslations('Upload')
    const router = useRouter()
    const addFiles = useImageCompressorStore(s => s.addFiles)
    const reset = useImageCompressorStore(s => s.reset)

    const handleFilesAdded = (files: File[]) => {
        reset()
        addFiles(files, f => f.type.startsWith('image/'))
        const accepted = files.filter(f => f.type.startsWith('image/'))
        if (accepted.length > 0) {
            trackToolEvent('tool_upload_started', {
                tool: 'image-compressor',
                file_count: accepted.length,
                file_kind: 'image',
            })
        }
        router.push('/compress-image/configurar')
    }

    return (
        <div className="mx-auto max-w-4xl">
            <ToolStepIndicator currentStep={1} baseUrl="/compress-image" />
            <div className="rounded-3xl bg-white p-4 shadow-2xl shadow-slate-200/50">
                <FileDropZone
                    accept="image/*"
                    icon="image"
                    title={t('selectImages')}
                    subtitle={t('subtitleImage')}
                    onFilesAdded={handleFilesAdded}
                />
            </div>
        </div>
    )
}
